import Facebook from '@clearkit/icons/services/Facebook';
import Hubspot from '@clearkit/icons/services/Hubspot';
import Javascript from '@clearkit/icons/services/Javascript';
import Salesforce from '@clearkit/icons/services/Salesforce';
import Segment from '@clearkit/icons/services/Segment';
import Slack from '@clearkit/icons/services/Slack';

import GoogleAnalytics from '~/images/destinations/GoogleAnalytics.svg';

const logos = {
  facebook: Facebook,
  google: GoogleAnalytics,
  hubspot: Hubspot,
  javascript: Javascript,
  salesforce: Salesforce,
  salesforcesandbox: Salesforce,
  segment: Segment,
  slack: Slack,
};

export default function Logo({ type, ...props }) {
  const Component = logos[type];

  if (!Component) {
    return null;
  }

  return <Component {...props} />;
}

Logo.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string.isRequired,
};
